import React, { FC } from "react";
import SideImageLayout from "@components/SideImageLayout/SideImageLayout";
import VerifyEmailForm from "@components/Onboarding/VerifyEmailForm/VerifyEmailForm";

const VerifyEmail: FC = () => {
  return (
    <SideImageLayout>
      <VerifyEmailForm />
    </SideImageLayout>
  );
};

export default VerifyEmail;
